@if (showBouncingArrow$ | async) {
    <i class="material-symbols-outlined {{ direction }}">arrow_{{ direction }}ward_alt</i>
}
